module.exports = __webpack_public_path__ + "media/styles/images/png/inline-arrow-down-teal-a72e1d5927fd65b0782883027b55027f.png";